import React from 'react';
import { motion } from 'framer-motion';
interface SalesSectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function SalesSection({
  children,
  className = '',
  id,
  delay = 0
}: SalesSectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut',
    delay
  }} className={`py-10 px-6 md:px-8 max-w-3xl mx-auto ${className}`} data-id="element-245">
      {children}
    </motion.section>;
}